window.addEventListener('load', () => {
    const listItems = document.getElementsByClassName('list-group-item');

    // Loop through each list item
    for (const listItem of listItems) {
        const closestActiveTab = listItem.closest('.active');

        if (closestActiveTab) {
            const accordionCollapse = closestActiveTab.parentElement.closest('.accordion-collapse');
            const accordionButton = accordionCollapse.previousElementSibling.querySelector('.accordion-button');

            if (accordionCollapse && accordionButton) {
                accordionButton.classList.remove('collapsed')
                accordionCollapse.classList.add('show')
            }
        }
    }
})